import { render } from "./AdminAboutMe.vue?vue&type=template&id=25dc05b4"
import script from "./AdminAboutMe.vue?vue&type=script&lang=js"
export * from "./AdminAboutMe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__